webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* global localStorage */



// Set in config/prod.env.js
var API_URL = "https://api.beautyscripts.com/api/v1" || 'http://localhost:3000/api/v1';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


var stringHelper = function () {
  function camelize(str) {
    return str.replace(/_([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  }

  function camelizeObject(obj) {
    var newObj = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var camelKey = camelize(key);
        if (Array.isArray(obj[key])) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[key][0]) === 'object') newObj[camelKey] = camelizeArrayOfObjects(obj[key]);else newObj[camelKey] = obj[key];
        } else {
          newObj[camelKey] = obj[key];
        }
      }
    }
    return newObj;
  }

  function camelizeArrayOfObjects(array) {
    if (!array) return;
    var newArray = [];
    array.forEach(function (object) {
      var camelObject = camelizeObject(object);
      newArray.push(camelObject);
    });
    return newArray;
  }

  function unCamelize(str) {
    return str.replace(/\.?([A-Z])/g, function (x, y) {
      return '_' + y.toLowerCase();
    }).replace(/^_/, '');
  }

  function unCamelizeObject(obj) {
    var newObj = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var unCamelKey = unCamelize(key);
        if (Array.isArray(obj[key])) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[key][0]) === 'object') newObj[unCamelKey] = unCamelizeArrayOfObjects(obj[key]);else newObj[unCamelKey] = obj[key];
        } else {
          newObj[unCamelKey] = obj[key];
        }
      }
    }
    return newObj;
  }

  function unCamelizeArrayOfObjects(array) {
    var newArray = [];
    array.forEach(function (object) {
      var unCamelObject = unCamelizeObject(object);
      newArray.push(unCamelObject);
    });
    return newArray;
  }

  function pluralizeString(string, itemLength) {
    if (itemLength === 1) return string;else return string + 's';
  }

  function insertOrAppend(string, addition) {
    var appendix = '';
    if (string && string.length > 0) appendix += ', ';
    appendix += addition;
    return appendix;
  }

  return {
    camelize: camelize,
    camelizeObject: camelizeObject,
    camelizeArrayOfObjects: camelizeArrayOfObjects,
    unCamelize: unCamelize,
    unCamelizeObject: unCamelizeObject,
    unCamelizeArrayOfObjects: unCamelizeArrayOfObjects,
    pluralizeString: pluralizeString,
    insertOrAppend: insertOrAppend
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (stringHelper);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_error__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_script__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_publicPro__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_scriptProductLinks__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_scriptCategories__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_networkRetailers__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_pwaDownloadPrompt__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_isMobileDevice__ = __webpack_require__(255);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_3__modules_error__["a" /* default */],
    script: __WEBPACK_IMPORTED_MODULE_4__modules_script__["a" /* default */],
    scriptProductLinks: __WEBPACK_IMPORTED_MODULE_6__modules_scriptProductLinks__["a" /* default */],
    scriptCategories: __WEBPACK_IMPORTED_MODULE_7__modules_scriptCategories__["a" /* default */],
    networkRetailers: __WEBPACK_IMPORTED_MODULE_8__modules_networkRetailers__["a" /* default */],
    publicPro: __WEBPACK_IMPORTED_MODULE_5__modules_publicPro__["a" /* default */],
    pwaDownloadPrompt: __WEBPACK_IMPORTED_MODULE_9__modules_pwaDownloadPrompt__["a" /* default */],
    isMobileDevice: __WEBPACK_IMPORTED_MODULE_10__modules_isMobileDevice__["a" /* default */]
  }
}));

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventBus_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utilities_EventBus__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navbar__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlankNavbar__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MainNavbar__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Foot__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_GenericModal__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_share_ShareProduct__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_product_link_ProductLinkDetails__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BxCarousel__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_utilities_DropNotification__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(26);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Beauty Scripts',
    // all titles will be injected into this template
    titleTemplate: '%s | Beauty Scripts'
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_4__components_Navbar__["a" /* default */],
    BlankNavbar: __WEBPACK_IMPORTED_MODULE_5__components_BlankNavbar__["a" /* default */],
    Foot: __WEBPACK_IMPORTED_MODULE_7__components_Foot__["a" /* default */],
    GenericModal: __WEBPACK_IMPORTED_MODULE_8__components_modals_GenericModal__["a" /* default */],
    ShareProduct: __WEBPACK_IMPORTED_MODULE_9__components_share_ShareProduct__["a" /* default */],
    BxCarousel: __WEBPACK_IMPORTED_MODULE_11__components_BxCarousel__["a" /* default */],
    DropNotification: __WEBPACK_IMPORTED_MODULE_12__components_utilities_DropNotification__["a" /* default */],
    ProductLinkDetails: __WEBPACK_IMPORTED_MODULE_10__components_product_link_ProductLinkDetails__["a" /* default */],
    MainNavbar: __WEBPACK_IMPORTED_MODULE_6__components_MainNavbar__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      modalContentComponent: null,
      modalProps: {},
      modalSuccessCallback: function modalSuccessCallback() {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    // NOTE: To display a modal from another component, pass the component
    // name to the EventBus as 'modalContentComponent'. Any modal you will be
    // displaying has to be registered here in App.vue
    __WEBPACK_IMPORTED_MODULE_3__components_utilities_EventBus__["a" /* default */].$on('showModal', function (payload) {
      _this.modalContentComponent = payload.modalContentComponent;
      _this.modalSuccessCallback = payload.modalSuccessCallback;
      _this.modalProps = payload.modalProps;
      _this.showModal = true;
    });
    __WEBPACK_IMPORTED_MODULE_3__components_utilities_EventBus__["a" /* default */].$on('hideModal', function () {
      _this.showModal = false;
    });
  },
  created: function created() {
    this.showPrompt();
    this.setIsMobileDevice();
    __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('getScriptCategories');
    __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('getProfessions');
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    currentUser: 'currentUser',
    currentPro: 'currentPro',
    globalError: 'errorMessage',
    hideDefaultMessage: 'hideDefault',
    showPwaDownloadPrompt: 'showPwaDownloadPrompt',
    isSettingCurrentUser: 'isSettingCurrentUser'
  }), {
    isRetractPaddingRoute: function isRetractPaddingRoute() {
      return this.$route.path === '/';
    },
    isConsumerView: function isConsumerView() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentPro).length > 0;
    },
    hideFooterRoutes: function hideFooterRoutes() {
      return this.$route.path === '/login';
    }
  }),
  methods: {
    clearError: function clearError() {
      __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('removeError');
    },
    hidePwaDownloadPrompt: function hidePwaDownloadPrompt() {
      __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('disablePwaDownloadPrompt');
    },
    showPrompt: function showPrompt() {
      // Detects if device is on iOS
      var isIos = function isIos() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        return (/iphone|ipad|ipod/.test(userAgent)
        );
      };
      // Detects if device is in standalone mode
      var isInStandaloneMode = function isInStandaloneMode() {
        return 'standalone' in window.navigator && window.navigator.standalone;
      };

      // Checks if should display install popup notification:
      if (isIos() && !isInStandaloneMode()) {
        __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('enablePwaDownloadPrompt');
      }
    },
    setIsMobileDevice: function setIsMobileDevice() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('setIsMobileDevice');
      }
    },
    onGenericModalClose: function onGenericModalClose() {
      this.showModal = false;
      if (this.$refs['generic-slot-component'] && this.$refs['generic-slot-component'].modalCloseCallback) {
        this.$refs['generic-slot-component'].modalCloseCallback();
      }
    }
  }
});

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_TermsLink__ = __webpack_require__(71);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  components: {
    TermsLink: __WEBPACK_IMPORTED_MODULE_2__components_utilities_TermsLink__["a" /* default */]
  },
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' })),
  methods: {
    openProProfile: function openProProfile() {
      var url = window.location.origin + '/' + this.currentUser.identifier;
      window.open(url, '_blank');
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      delete localStorage.token;
      this.$router.replace(this.$route.query.redirect || '/login');
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsLink_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0fdba8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsLink_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0fdba8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TermsLink',
  props: {
    text: {
      type: String,
      default: 'Terms'
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Ikljb25IYW1idXJnZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODggLTIyKSI+CiAgICA8cGF0aCBpZD0iTWVudSIgZD0iTS02MTYwLDE0VjEyaDEwdjJabTAtNlY2aDE2VjhabTAtNlYwaDE2VjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NDQ4IDIzKSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNDQ2IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDQ2IiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg4IDIyKSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjQgMTIiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJJY29uX0tleWJvYXJkX0Fycm93Xy1fVXBfRGFyayIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9Ikljb24gLyBLZXlib2FyZCBBcnJvdyAtIFVwIC8gRGFyayIgZD0iTTEwLjYsNy40LDYsMi44LDEuNCw3LjQsMCw2LDYsMGw2LDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjQpIHJvdGF0ZSg5MCkiLz4KPC9zdmc+Cg=="

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BlankNavbar',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_arrayHelper__ = __webpack_require__(165);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainNavbar',
  components: {},
  data: function data() {
    return {
      showMenu: false,
      searchQuery: this.initializeSearchQuery()
    };
  },
  mounted: function mounted() {
    this.activateNavScroll();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['currentPro']), {
    isConsumerView: function isConsumerView() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.currentPro).length > 0;
    },
    isLandingPage: function isLandingPage() {
      return this.$route.path === '/';
    }
  }),
  methods: {
    activateNavScroll: function activateNavScroll() {
      window.addEventListener('scroll', function () {
        var mainNav = $('.main-navbar');

        if (window.scrollY < 100) {
          // If we are at the top of the screen
          mainNav.removeClass('fadeBackground');
        } else {
          mainNav.addClass('fadeBackground');
        }
      });
    },
    initializeSearchQuery: function initializeSearchQuery() {
      return this.$route.query.searchQuery || '';
    },
    onMenuClick: function onMenuClick(event) {
      // Don't close menu when clicking on search/categories
      if (event.target.closest('.master-search')) return;
      if (event.target.closest('.categories-menu')) return;
      this.showMenu = false;
    },
    onEnterSearch: function onEnterSearch(newQuery) {
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { searchQuery: newQuery });

      this.$router.push({ name: 'MasterSearch', query: query }).catch(function (err) {
        return err;
      });

      this.showMenu = false;

      this.$refs.searchBarDesktop.closeCategories();
      this.$refs.searchBarMobile.closeCategories();
    },
    onClearSearch: function onClearSearch() {
      this.onEnterSearch(undefined);
    },
    onCategoryClick: function onCategoryClick(category) {
      var categoryArray = this.$route.query.categories ? this.$route.query.categories.slice() : [];
      var id = category.id.toString();

      if (!Array.isArray(categoryArray)) categoryArray = [categoryArray];

      if (categoryArray.includes(id)) {
        __WEBPACK_IMPORTED_MODULE_4__helpers_arrayHelper__["a" /* default */].removeValue(categoryArray, id);
      } else {
        categoryArray.push(id);
      }

      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { categories: categoryArray });

      this.$router.push({ name: 'MasterSearch', query: query }).catch(function (err) {
        return err;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNC4zMTQgMzQuMDkzIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogIzAwMDsKICAgICAgICBzdHJva2Utd2lkdGg6IDJweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9IkxvZ29JY29uX0hvbWVCdXR0b24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOS45ODUgLTExKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8yMDE3IiBkYXRhLW5hbWU9IlBhdGggMjAxNyIgZD0iTTcuMzEzLDBjMi4xNDYsMCwzLjg1NSwxLjAwOCwzLjg1NSwzLjI0MkEyLjMsMi4zLDAsMCwxLDkuNTkxLDUuNDc2LDIuODA2LDIuODA2LDAsMCwxLDExLjUxOCw4LjFjMCwyLjUtMS45NzEsMy4yNDItNC4yMDUsMy4yNDJIMi4xVjBaTTMuOSw0LjY4N0g3LjMxM2MxLjM1OCwwLDIuMDU5LS41MjYsMi4wNTktMS40NDYsMC0uNzg5LS43LTEuNjIxLTIuMDU5LTEuNjIxSDMuOVptMCw0Ljk5NEg3LjMxM2MxLjAwOCwwLDIuNDA5LS4zMDcsMi40MDktMS41NzcsMC0xLjIyNy0xLjM1OC0xLjc1Mi0yLjM2NS0xLjc1MkgzLjk0VjkuNjgxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzUuNzc0IDI2LjMyNCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzIwMjgiIGRhdGEtbmFtZT0iUGF0aCAyMDI4IiBkPSJNLjA1NCwwSDEuNzQ1TDEuNjkxLDEwLjk1MkgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMzIxIDM3LjM0OSkgcm90YXRlKC00NSkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzIwMTkiIGRhdGEtbmFtZT0iUGF0aCAyMDE5IiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNzcuMDg3LDM2NS42NzZIMTU3Ljc1VjMzMy43NWgzMS45MjZ2MjAuMDc4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTM2Ljc2NSAtMzIxLjc1KSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjAyOSIgZGF0YS1uYW1lPSJQYXRoIDIwMjkiIGQ9Ik0uMDU0LDBIMS43NDVMMS42OTEsMTAuOTUySDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Ni41NTUgNDUuMDkzKSByb3RhdGUoLTEzNSkiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_LoadingSpinner__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_TermsLink__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formHelper__ = __webpack_require__(82);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Foot',
  components: {
    TermsLink: __WEBPACK_IMPORTED_MODULE_1__components_utilities_TermsLink__["a" /* default */],
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_0__components_utilities_LoadingSpinner__["a" /* default */]
  },
  data: function data() {
    return {
      isAddingEmail: false,
      mailingEmailAddress: null,
      emailMessage: null
    };
  },

  computed: {
    isEmailValid: function isEmailValid() {
      return __WEBPACK_IMPORTED_MODULE_2__helpers_formHelper__["a" /* default */].validateEmail(this.mailingEmailAddress);
    }
  },
  methods: {
    addToMailingList: function addToMailingList() {
      var _this = this;

      this.isAddingEmail = true;

      this.axios.post('/public/users/add_bx_lover', { email_address: this.mailingEmailAddress }).then(function (response) {
        _this.mailingEmailAddress = null;
        _this.isAddingEmail = false;
        _this.emailMessage = 'Thanks! You have successfully been added to our mailing list.';
      });
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpinner_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c3e472_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpinner_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66c3e472"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c3e472_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoadingSpinner',
  props: ['isBlack']
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* eslint no-useless-escape: 0 */
var formHelper = function () {
  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  return {
    validateEmail: validateEmail
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (formHelper);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GenericModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    hideCloseMobile: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 50
    },
    minModalHeight: {
      type: Number,
      default: 10
    },
    fullHeightMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      modalWidth: this.width
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Close on ESC key
    document.addEventListener('keydown', function (e) {
      if (_this.show && e.keyCode === 27) {
        _this.$emit('close');
      }
    });
    window.addEventListener('resize', function () {
      _this.setModalWidth();
    });
  },
  created: function created() {
    this.setModalWidth();
  },

  methods: {
    closeModal: function closeModal(event) {
      if (event.target.className.includes('no-close')) return;
      if (event.target.closest('.modal-container')) return;
      this.$emit('close');
    },
    setModalWidth: function setModalWidth() {
      if (window.innerWidth < 768) {
        this.modalWidth = 100;
      } else {
        this.modalWidth = this.width;
      }
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_EventBus__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utilities_LoadingSpinner__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_PhoneNumber__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formHelper__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_stringHelper__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareProduct',
  props: {
    modalProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    LoadingSpinner: __WEBPACK_IMPORTED_MODULE_3__components_utilities_LoadingSpinner__["a" /* default */],
    PhoneNumber: __WEBPACK_IMPORTED_MODULE_4__components_form_PhoneNumber__["a" /* default */]
  },
  data: function data() {
    return {
      isEmailShareOpen: false,
      isSmsShareOpen: false,
      isUrlShareOpen: false,
      emailAddress: '',
      emailIsSending: false,
      smsIsSending: false,
      isPhoneNumberValid: false,
      isLinkLoading: false,
      shareLink: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['currentUser']), {
    isEmailValid: function isEmailValid() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_formHelper__["a" /* default */].validateEmail(this.emailAddress);
    }
  }),
  methods: {
    onLinkShareClick: function onLinkShareClick() {
      this.isUrlShareOpen = !this.isUrlShareOpen;
      if (this.isUrlShareOpen) this.initiateLinkShare();
    },
    sendEmailShare: function sendEmailShare() {
      if (this.emailIsSending) return;
      this.emailIsSending = true;
      this.createProductLinkForUser(this.onProductCreateEmail);
    },
    onProductCreateEmail: function onProductCreateEmail(productLink) {
      var _this = this;

      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/email', { email_address: this.emailAddress }).then(function (response) {
        return _this.onEmailSent(response.data);
      });
    },
    sendSmsShare: function sendSmsShare() {
      if (this.smsIsSending) return;
      this.smsIsSending = true;
      this.createProductLinkForUser(this.onProductCreateSms);
    },
    onProductCreateSms: function onProductCreateSms(productLink) {
      var _this2 = this;

      var phoneNumber = this.$refs['phone-number-component'].fullPhoneNumber;
      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/sms', { phone_number: phoneNumber }).then(function (response) {
        return _this2.onSmsSent(response.data);
      });
    },
    createProductLinkForUser: function createProductLinkForUser(callback) {
      this.axios.post('users/' + this.currentUser.id + '/product_links', { product_link: __WEBPACK_IMPORTED_MODULE_6__helpers_stringHelper__["a" /* default */].unCamelizeObject(this.modalProps.productLink) }).then(function (response) {
        callback(__WEBPACK_IMPORTED_MODULE_6__helpers_stringHelper__["a" /* default */].camelizeObject(response.data.product_link));
      });
    },
    initiateLinkShare: function initiateLinkShare() {
      // First, we need to make sure that the current user is associated with this product.
      // Make a POST request to either create or fetch the product for this user, and then create the share link.
      if (this.isLinkLoading) return;

      this.isLinkLoading = true;
      this.shareLink = '';
      this.createProductLinkForUser(this.createShareLink);
    },
    createShareLink: function createShareLink(productLink) {
      var _this3 = this;

      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/url').then(function (response) {
        _this3.onShareLinkCreated(response.data);
      });
    },
    onEmailSent: function onEmailSent(data) {
      __WEBPACK_IMPORTED_MODULE_2__components_utilities_EventBus__["a" /* default */].$emit('drop', {
        message: 'Product successfully sent to: ' + this.emailAddress,
        statusCode: 1
      });

      this.emailAddress = '';
      this.isEmailShareOpen = false;
      this.emailIsSending = false;
    },
    onSmsSent: function onSmsSent(data) {
      __WEBPACK_IMPORTED_MODULE_2__components_utilities_EventBus__["a" /* default */].$emit('drop', {
        message: 'Product successfully sent to: ' + this.$refs['phone-number-component'].fullPhoneNumber,
        statusCode: 1
      });

      this.$refs['phone-number-component'].clearPhoneNumber();
      this.smsIsSending = false;
      this.isSmsShareOpen = false;
    },
    onShareLinkCreated: function onShareLinkCreated(data) {
      this.shareLink = data.share_link;
      this.isLinkLoading = false;
    },
    copyShareLink: function copyShareLink() {
      this.$copyText(this.shareLink); // This uses VueClipboard
      __WEBPACK_IMPORTED_MODULE_2__components_utilities_EventBus__["a" /* default */].$emit('drop', {
        message: 'Link copied to clipboard!',
        statusCode: 1
      });
      this.isUrlShareOpen = false;
    },

    // EXTERNAL METHOD
    modalCloseCallback: function modalCloseCallback() {
      this.isUrlShareOpen = false;
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PhoneNumber',
  props: {
    setPhoneNumberValid: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    setPhoneNumberInvalid: {
      type: Function,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      areaCode: '',
      prefix: '',
      lineNumber: ''
    };
  },

  computed: {
    fullPhoneNumber: function fullPhoneNumber() {
      return '+1' + this.areaCode + this.prefix + this.lineNumber;
    }
  },
  mounted: function mounted() {
    this.$el.querySelector('input.area-code').focus();
  },

  methods: {
    validatePhoneNumber: function validatePhoneNumber() {
      if (this.areaCode.length === 3 && this.prefix.length === 3 && this.lineNumber.length === 4) {
        this.setPhoneNumberValid();
      } else {
        this.setPhoneNumberInvalid();
      }
    },
    checkLengthAndTab: function checkLengthAndTab(event) {
      var maxLength = 3;
      var length = event.target.value.length;
      if (length === maxLength) {
        event.target.nextElementSibling.focus();
        event.target.value = event.target.value.substring(0, maxLength);
      } else {
        var modelName = event.target.getAttribute('data-modelName');
        var subString = event.target.value.substring(0, maxLength);
        this[modelName] = subString; // This fixes issue with user going back and inputting another number
        event.target.value = event.target.value.substring(0, maxLength);
      }
      this.validatePhoneNumber();
    },
    checkLineNumberLength: function checkLineNumberLength(event) {
      var maxLength = 4;
      var length = event.target.value.length;
      if (length === maxLength) {
        event.target.blur();
        event.target.value = event.target.value.substring(0, maxLength);
      } else {
        var modelName = event.target.getAttribute('data-modelName');
        var subString = event.target.value.substring(0, maxLength);
        this[modelName] = subString; // This fixes issue with user going back and inputting another number
        event.target.value = event.target.value.substring(0, maxLength);
      }
      this.validatePhoneNumber();
    },
    clearPhoneNumber: function clearPhoneNumber() {
      this.areaCode = '';
      this.prefix = '';
      this.lineNumber = '';
      this.validatePhoneNumber();
    }
  }
});

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_EventBus__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductLinkDetails',
  props: {
    modalProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productLink: this.modalProps.productLink,
      addToScriptClick: this.modalProps.addToScriptClick,
      showAddToScript: this.modalProps.showAddToScript,
      userProductLinkUrl: null
    };
  },
  updated: function updated() {
    // Need to update every time modal is opened
    this.productLink = this.modalProps.productLink;
    this.addToScriptClick = this.modalProps.addToScriptClick;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({ currentUser: 'currentUser' }), {
    facebookShareUrl: function facebookShareUrl() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + this.userProductLinkUrl;
    },
    twitterShareUrl: function twitterShareUrl() {
      var text = encodeURI('Check out this product I found using Beauty Scripts!');
      return 'https://twitter.com/intent/tweet?url=' + encodeURI(this.userProductLinkUrl) + '&text=' + text;
    },
    pinterestShareUrl: function pinterestShareUrl() {
      var text = encodeURI('Check out this product I found using Beauty Scripts!');
      return 'http://pinterest.com/pin/create/button/?url=' + encodeURI(this.userProductLinkUrl) + '&media=' + encodeURI(this.modalProps.productLink.imageUrl) + '&description=' + text + '&image_url=' + encodeURI(this.modalProps.productLink.imageUrl);
    }
  }),
  methods: {
    onCopyShareLinkClick: function onCopyShareLinkClick() {
      if (!this.userProductLinkUrl) {
        this.createProductLinkForUser(this.copyShareLink);
      } else {
        this.copyShareLink();
      }
    },
    copyShareLink: function copyShareLink(productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url;

      this.$copyText(this.userProductLinkUrl); // This uses VueClipboard
      __WEBPACK_IMPORTED_MODULE_1__components_utilities_EventBus__["a" /* default */].$emit('drop', {
        message: 'Link copied to clipboard!',
        statusCode: 1
      });
    },
    onLinkClick: function onLinkClick() {
      if (this.userProductLinkUrl) {
        this.onProductLinkCreated();
      } else {
        this.createProductLinkForUser(this.onProductLinkCreated);
      }
    },
    createProductLinkForUser: function createProductLinkForUser(callback) {
      this.axios.post('users/' + this.currentUser.id + '/product_links', { product_link: __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper__["a" /* default */].unCamelizeObject(this.modalProps.productLink) }).then(function (response) {
        callback(__WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper__["a" /* default */].camelizeObject(response.data.product_link));
      });
    },
    onProductLinkCreated: function onProductLinkCreated(productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url;
      window.open(this.userProductLinkUrl, '_blank');
    },
    showFacebook: function showFacebook(productLink) {
      return productLink.network.name !== 'rakuten';
    },
    facebookShareCallback: function facebookShareCallback(productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url;
      window.open(this.facebookShareUrl, '_blank');
    },
    twitterShareCallback: function twitterShareCallback(productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url;
      window.open(this.twitterShareUrl, '_blank');
    },
    pinterestShareCallback: function pinterestShareCallback(productLink) {
      if (productLink) this.userProductLinkUrl = productLink.url;
      window.open(this.pinterestShareUrl, '_blank');
    },

    // EXTERNAL METHOD
    modalCloseCallback: function modalCloseCallback() {
      this.userProductLinkUrl = null;
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BxCarousel',
  props: {
    modalProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentSlide: 1
    };
  },
  created: function created() {
    // setTimeout(() => {
    //   $('.bx-carousel').on('swipe', (event) => {
    //     this.handleSwipe(event)
    //   })
    // }, 1000)
  },

  computed: {
    currentImageSource: function currentImageSource() {
      return __webpack_require__(205)("./images" + this.modalProps.imagePath + '_' + this.currentSlide + '.jpg');
    }
  },
  methods: {
    nextSlide: function nextSlide() {
      if (this.currentSlide === this.modalProps.slideLength) this.$emit('close');else this.currentSlide += 1;
    },
    prevSlide: function prevSlide() {
      if (this.currentSlide === 1) return;
      this.currentSlide -= 1;
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_EventBus__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DropNotification',
  data: function data() {
    return {
      message: '',
      statusCode: null,
      statusMap: {
        1: 'green',
        2: 'yellow',
        3: 'red'
      },
      messageQueue: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__components_utilities_EventBus__["a" /* default */].$on('drop', function (payload) {
      _this.messageQueue.push(payload);
      if (_this.messageQueue.length > 1) return;
      _this.show();
    });
  },

  methods: {
    show: function show() {
      var _this2 = this;

      var payload = this.messageQueue[0];
      if (!payload) return;

      var duration = 3000;

      if (payload.duration) duration = payload.duration;
      this.message = payload.message;
      this.statusCode = payload.statusCode;

      $('.notification-container').removeClass('hideContainer');
      $('.drop-notification').addClass('slideEffect');

      // Adds slideUp animation
      setTimeout(function () {
        $('.drop-notification').removeClass('slideEffect');
        $('.notification-container').addClass('hideContainer');
        _this2.messageQueue.splice(0, 1);
        _this2.statusCode = null;
        _this2.show();
      }, duration);
    },
    clearNotification: function clearNotification() {
      $('.drop-notification').removeClass('slideEffect');
      $('.notification-container').addClass('hideContainer');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS4zMDUgMjkuMzA1Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjNzVhNTZjOwogICAgICB9CgogICAgICAuY2xzLTIgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjZmZmOwogICAgICAgIHN0cm9rZS13aWR0aDogMnB4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iSWNvbl9Db25maXJtYXRpb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NSAtNzQyKSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzI3NiIgZGF0YS1uYW1lPSJFbGxpcHNlIDI3NiIgY2xhc3M9ImNscy0xIiBjeD0iMTQuNjUyIiBjeT0iMTQuNjUyIiByPSIxNC42NTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1IDc0MikiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzIwMjciIGRhdGEtbmFtZT0iUGF0aCAyMDI3IiBjbGFzcz0iY2xzLTIiIGQ9Ik00NDczLjI1NCwxNjU4LjMwNmw1LjQ1NSw1LjIyNCw4LjQ0LTkuNTMzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQyMC40NjMgLTkwMi44NDUpIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_vue_axios_axios__ = __webpack_require__(15);






var User = function () {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(User, [{
    key: 'fullName',
    value: function fullName() {
      return this.firstName + ' ' + this.lastName;
    }
  }, {
    key: 'hometown',
    value: function hometown() {
      var str = '';
      if (this.city) str += this.city;
      if (this.city && this.state) str += ', ';
      if (this.state) str += this.state;
      return str;
    }
  }, {
    key: 'personalUrlLink',
    value: function personalUrlLink() {
      return 'http://' + this.personalUrl;
    }
  }], [{
    key: 'fromToken',
    value: function fromToken(token) {
      var obj = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token);

      return __WEBPACK_IMPORTED_MODULE_4__api_vue_axios_axios__["a" /* default */].get('/users/' + obj.user_id).then(function (request) {
        return new User(request.data.user);
      }).catch(function (request) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(request);
      });
    }
  }, {
    key: 'fromObject',
    value: function fromObject(userObject) {
      return new User(userObject);
    }
  }]);

  function User(user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, User);

    this.id = user.id;
    this.emailAddress = user.email_address;
    this.firstName = user.first_name;
    this.lastName = user.last_name;
    this.personalUrl = user.personal_url;
    this.city = user.city;
    this.state = user.state;
    this.profession = user.profession;
    this.hasAvatar = user.has_avatar;
    this.avatar = user.avatar;
    this.avatarMidsize = user.avatar_midsize;
    this.avatarThumbnail = user.avatar_thumbnail;
    this.paypalEmailAddress = user.paypal_email_address;
    this.referralCode = user.referral_code;
    this.addressLineOne = user.address_line_one;
    this.addressLineTwo = user.address_line_two;
    this.zipCode = user.zip_code;
    this.identifier = user.identifier;
    this.bio = user.bio;
    this.createdAt = user.created_at;
  }

  return User;
}();

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShutDownPage',
  data: function data() {
    return {};
  },
  created: function created() {}
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_vue_axios_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_tables_2__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slider_component__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_date__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_utility__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_font_awesome_css_font_awesome_css__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_styles_shared_css__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_styles_shared_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_styles_shared_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_styles_vue_slider_css__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_styles_vue_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_styles_vue_slider_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Native Vue stuff





// Stuff to #use






// import VueIntercom from 'vue-intercom'


// Mixins



// CSS




// IMPT we have to set the token in our header every single time
__WEBPACK_IMPORTED_MODULE_5__api_vue_axios_axios__["a" /* default */].interceptors.request.use(function (request) {
  // Get token from localStorage
  var token = localStorage.token;
  // Update token axios header
  if (token) {
    request.headers['Authorization'] = 'Bearer ' + token;
  }
  return request;
});

// TODO this should be cleaned up, and moved out of this file.
// Add simple global error handling. This is the default and can be overridden during individual API calls.
__WEBPACK_IMPORTED_MODULE_5__api_vue_axios_axios__["a" /* default */].interceptors.response.use(function (response) {
  // all is well, clear any lingering errors
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('removeError');
  return response;
}, function (error) {
  // display error message
  // Handle network error first
  if (!error.response) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addError', { errorMessage: 'There was a problem connecting to our servers. Please login and try again.', hideDefault: true });
    return;
  }
  /// 404 will be handled in router
  if (error.response.status === 404) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);

  // We want to first handle errors for expired tokens
  if (error.response.data && error.response.data.error === 'INVALID_TOKEN') {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addError', { errorMessage: 'Your session has expired. Please log in again', hideDefault: true });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  // Then we want to bypass showing error message for incorrect login
  if (error.response.status === 401) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  // otherwise just show the error!
  var errorMessage = '';
  if (error.response.data && error.response.data.error) errorMessage = error.response.data.error;else if (error.response && error.response.statusText) errorMessage = error.response.statusText;else errorMessage = error.message;

  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('addError', { errorMessage: errorMessage });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Use stuff
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5__api_vue_axios_axios__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_tables_2__["ClientTable"]);
// Vue.use(VueIntercom, { appId: 'mcbeomku' })
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
  id: 'UA-139852130-1',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  checkDuplicatedScript: true,
  debug: {
    enabled: !"production" === 'production',
    sendHitTask: "production" === 'production'
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_meta__["a" /* default */], {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('VueSlider', __WEBPACK_IMPORTED_MODULE_10_vue_slider_component___default.a);

// Add global mixins
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_12__mixins_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_13__mixins_utility__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

// Could go elsewhere...
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('showOnScroll', {
  inserted: function inserted(el, binding) {
    el.style['visibility'] = 'hidden';

    var f = function f(evt) {
      if (window.scrollY > binding.value) el.style['visibility'] = 'visible';else el.style['visibility'] = 'hidden';
    };
    window.addEventListener('scroll', f);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('click-outside', {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_5__api_vue_axios_axios__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185a6dbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(256);
function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185a6dbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43659c0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(157);
function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43659c0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43659c0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"terms",attrs:{"href":"https://bs-app.s3.amazonaws.com/public/bx-terms.pdf","target":"_blank"}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar bg-nav"},[_c('router-link',{attrs:{"to":"/home"}},[_c('img',{staticClass:"bs-logo",attrs:{"src":__webpack_require__(73)}})]),_vm._v(" "),_c('section',{staticClass:"menu-right"},[_c('router-link',{attrs:{"to":"/new-script"}},[_c('img',{staticClass:"new-script-button",attrs:{"src":__webpack_require__(158)}})]),_vm._v(" "),_c('div',{staticClass:"user-menu"},[_c('img',{staticClass:"hamburger",attrs:{"src":__webpack_require__(74)},on:{"click":function($event){_vm.showMenu = true}}}),_vm._v(" "),_c('div',{staticClass:"slideout-menu",class:{ visible : _vm.showMenu },on:{"click":function($event){_vm.showMenu = false}}},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"menu-top",on:{"click":function($event){return _vm.openProProfile()}}},[(_vm.currentUser.hasAvatar)?_c('div',{staticClass:"profile-image"},[_c('img',{staticClass:"user-image fade-hover",attrs:{"src":_vm.currentUser.avatarThumbnail}})]):_c('div',{staticClass:"profile-image"},[_c('img',{staticClass:"user-image",attrs:{"src":__webpack_require__(159)}})]),_vm._v(" "),_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.currentUser.fullName()))]),_vm._v(" "),_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.currentUser.hometown()))]),_vm._v(" "),_c('span',{staticClass:"truncate grayed"},[_vm._v(_vm._s(_vm.currentUser.profession))]),_vm._v(" "),_c('span',{staticClass:"truncate grayed"},[_vm._v(_vm._s(_vm.currentUser.personalUrl))]),_vm._v(" "),_c('span',{staticClass:"truncate grayed"},[_vm._v("My Bx Profile")])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/user-profile"}},[_vm._v(_vm._s(_vm.capitalize("Scripts")))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/user-settings"}},[_vm._v(_vm._s(_vm.capitalize("Settings")))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/analytics"}},[_vm._v(_vm._s(_vm.capitalize("analytics")))]),_vm._v(" "),_c('TermsLink',{attrs:{"text":"TERMS OF SERVICE"}}),_vm._v(" "),_c('a',{attrs:{"href":"https://blog.beautyscripts.com/support","target":"_blank"}},[_vm._v(_vm._s(_vm.capitalize("help")))]),_vm._v(" "),_c('a',{attrs:{"href":"http://blog.beautyscripts.com","target":"_blank"}},[_vm._v(_vm._s(_vm.capitalize("bx journal")))]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.capitalize("Logout")))])],1)])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-container"},[_c('img',{staticClass:"arrow-right",attrs:{"src":__webpack_require__(75)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAyOCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJfSWNvbl9BZGRTY3JpcHQiIGRhdGEtbmFtZT0iK0ljb24vQWRkU2NyaXB0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEyNSAtMjMpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEiIGN4PSIxNCIgY3k9IjE0IiByPSIxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyNSAyMykiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk1NCIgZGF0YS1uYW1lPSJQYXRoIDk1NCIgY2xhc3M9ImNscy0xIiBkPSJNOC41OTUuOTQ1LDcuNjUsMCw0LjMsMy4zNTIsMS4xNy4yMjUuMjI1LDEuMTcsMy4zNTIsNC4zLDAsNy42NWwuOTQ1Ljk0NUw0LjMsNS4yNDIsNy40MjUsOC4zN2wuOTQ1LS45NDVMNS4yNDIsNC4zWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEzMi45MjMgMzcpIHJvdGF0ZSgtNDUpIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/no-profile-image.afcdf71.png";

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankNavbar_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054efabe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlankNavbar_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-054efabe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlankNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054efabe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlankNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar bg-nav"},[_c('router-link',{attrs:{"to":"/home"}},[_c('img',{staticClass:"bs-logo",attrs:{"src":__webpack_require__(73)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNavbar_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be0ce50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNavbar_vue__ = __webpack_require__(166);
function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5be0ce50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be0ce50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var arrayHelper = function () {
  function findIndex(array, value, propertyName) {
    if (!array) return -1;
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i][propertyName] === value) return i;
    }
    return -1;
  }

  function findObjectByValue(array, value, propertyName) {
    var index = findIndex(array, value, propertyName);
    if (index === -1) return null;
    return array[index];
  }

  function removeValue(array, value) {
    var index = array.indexOf(value);
    if (index > -1) array.splice(index, 1);
  }

  function sortByObjectKey(array, key) {
    return array.sort(function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    });
  }

  function removeObjectByValue(array, value, propertyName) {
    var index = findIndex(array, value, propertyName);
    if (index === -1) return null;
    array.splice(index, 1);
  }

  return {
    findObjectByValue: findObjectByValue,
    findIndex: findIndex,
    removeValue: removeValue,
    sortByObjectKey: sortByObjectKey,
    removeObjectByValue: removeObjectByValue
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (arrayHelper);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"bg-nav navbar main-navbar",class:{ isTransparent : _vm.isLandingPage }},[_c('div',{staticClass:"inner"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"bs-logo",attrs:{"src":__webpack_require__(78)}})]),_vm._v(" "),_c('section',{staticClass:"menu-right"},[_c('div',{staticClass:"hide-tablet"},[(!_vm.isConsumerView)?_c('router-link',{attrs:{"to":"/master-search/scripts"}},[_vm._v("\n            DIRECTORY\n          ")]):_vm._e(),_vm._v(" "),(!_vm.isConsumerView)?_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n            LOG IN\n          ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"user-menu show-only-tablet"},[_c('img',{staticClass:"hamburger",attrs:{"src":__webpack_require__(74)},on:{"click":function($event){_vm.showMenu = true}}})])])],1)]),_vm._v(" "),_c('div',{staticClass:"slideout-menu",class:{ visible : _vm.showMenu },on:{"click":function($event){return _vm.onMenuClick($event)}}},[_c('div',{staticClass:"inner"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"scripts-btn",attrs:{"to":"/master-search/scripts"}},[_vm._v("\n        DIRECTORY\n      ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n        LOG IN\n      ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-container"},[_c('img',{staticClass:"arrow-right",attrs:{"src":__webpack_require__(75)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649ef364_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_649ef364_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(_vm.isBlack)?_c('img',{attrs:{"src":__webpack_require__(171)}}):_c('img',{attrs:{"src":__webpack_require__(172)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjM4IiBoZWlnaHQ9IjM4IiB2aWV3Qm94PSIwIDAgMzggMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPgogICAgICAgICAgICA8cGF0aCBkPSJNMzYgMThjMC05Ljk0LTguMDYtMTgtMTgtMTgiPgogICAgICAgICAgICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0KICAgICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iCiAgICAgICAgICAgICAgICAgICAgdHlwZT0icm90YXRlIgogICAgICAgICAgICAgICAgICAgIGZyb209IjAgMTggMTgiCiAgICAgICAgICAgICAgICAgICAgdG89IjM2MCAxOCAxOCIKICAgICAgICAgICAgICAgICAgICBkdXI9IjFzIgogICAgICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+CiAgICAgICAgICAgIDwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjM4IiBoZWlnaHQ9IjM4IiB2aWV3Qm94PSIwIDAgMzggMzgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjUiIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIvPgogICAgICAgICAgICA8cGF0aCBkPSJNMzYgMThjMC05Ljk0LTguMDYtMTgtMTgtMTgiPgogICAgICAgICAgICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0KICAgICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iCiAgICAgICAgICAgICAgICAgICAgdHlwZT0icm90YXRlIgogICAgICAgICAgICAgICAgICAgIGZyb209IjAgMTggMTgiCiAgICAgICAgICAgICAgICAgICAgdG89IjM2MCAxOCAxOCIKICAgICAgICAgICAgICAgICAgICBkdXI9IjFzIgogICAgICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+CiAgICAgICAgICAgIDwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('section',{staticClass:"half-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"half-block mailing"},[_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mailingEmailAddress),expression:"mailingEmailAddress"}],attrs:{"type":"text","name":"mailing-list","placeholder":"Join our mailing list."},domProps:{"value":(_vm.mailingEmailAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mailingEmailAddress=$event.target.value}}}),_vm._v(" "),_c('button',{attrs:{"disabled":!_vm.isEmailValid,"type":"submit","name":"button"},on:{"click":function($event){return _vm.addToMailingList()}}},[(_vm.isAddingEmail)?_c('LoadingSpinner',{attrs:{"isBlack":true}}):_c('span',[_vm._v("SUBMIT")])],1)]),_vm._v(" "),(_vm.emailMessage)?_c('span',[_vm._v(_vm._s(_vm.emailMessage))]):_vm._e()]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"half-block links"},[_c('router-link',{attrs:{"to":{ name: 'LearnMore' }}},[_vm._v("About")]),_vm._v(" "),_c('a',{staticClass:"privacy",attrs:{"href":"https://blog.beautyscripts.com/privacy","target":"_blank"}},[_vm._v("Privacy")]),_vm._v(" "),_c('TermsLink')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-block social"},[_c('a',{attrs:{"href":"https://www.instagram.com/beautyscripts/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(174)}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/beautyscripts/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(175)}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.pinterest.com/beautyscripts/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(176)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-block copyright"},[_c('span',{staticClass:"copy"},[_vm._v("All Rights Reserved, Beauty Scripts, LLC 2021")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTUxMiAyNTZjMC0xNDEuNC0xMTQuNi0yNTYtMjU2LTI1NnMtMjU2IDExNC42LTI1NiAyNTYgMTE0LjYgMjU2IDI1NiAyNTZjMS41IDAgMyAwIDQuNS0uMXYtMTk5LjJoLTU1di02NC4xaDU1di00Ny4yYzAtNTQuNyAzMy40LTg0LjUgODIuMi04NC41IDIzLjQgMCA0My41IDEuNyA0OS4zIDIuNXY1Ny4yaC0zMy42Yy0yNi41IDAtMzEuNyAxMi42LTMxLjcgMzEuMXY0MC44aDYzLjVsLTguMyA2NC4xaC01NS4ydjE4OS41YzEwNy0zMC43IDE4NS4zLTEyOS4yIDE4NS4zLTI0Ni4xeiIvPjwvc3ZnPgo="

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjUuNjI2IDI1LjYyNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjUuNjI2IDI1LjYyNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIHN0eWxlPSJmaWxsOiMwMzAxMDQ7IiBkPSJNMTIuODEyLDBDNS43MzYsMCwwLDUuNzM2LDAsMTIuODEyYzAsNS40MjEsMy4zNzIsMTAuMDQ1LDguMTI4LDExLjkxNwoJCWMtMC4wMjEtMC40MzgtMC4wMTgtMi43MDUsMS41Ni05LjQ3NGMwLjIxMS0yLjI1OC0wLjA4Mi0zLjA1OS0wLjA4Mi0zLjk5N2MwLTIuMTI5LDEuMTA2LTIuNTc4LDEuNzUyLTIuNTc4CgkJYzAuOTIxLDAsMi4xOTMsMC4zNTIsMi4xOTMsMS44MzZjMCwxLjctMS4zODYsMi4xNDctMS4zODYsMi4xNDdzLTAuMSwwLjQzNS0wLjIxNSwxLjY0M2MtMC4xMTUsMS4yMSwwLjM2OSwyLjUyLDIuMzQzLDIuNTIKCQljMy4xNjUsMCwzLjY1My00LjM5MywzLjY1My01LjYwMmMwLTEuNjctMS4yMjQtNS4wNi01LjAyNC01LjA2Yy01LjA2OCwwLTUuOTQsNC41NC01Ljk0LDUuNzUxYzAsMC41MTgsMC4xNDMsMS40MzIsMC4yNDEsMS44MjMKCQljMC45NTcsMC4xNTUsMC44NTgsMS40NjUsMC40NDksMS44MzdjLTAuNDU1LDAuNDA5LTIuNzkzLDAuODk2LTIuNzkzLTQuMjM2YzAtNC44ODcsNC4zNTYtNy40MDUsOC4xNzktNy40MDUKCQljMy42MzksMCw3LjYwMywyLjUxMSw3LjYwMyw3LjM0OGMwLDQuMzE4LTMuMTA0LDcuNzE4LTYuMzY0LDcuNzE4Yy0xLjk1OCwwLTIuOTk2LTEuNjEzLTIuOTk2LTEuNjEzCgkJYzAsMS41MS0yLjc3Myw2LjY5OS0zLjEyOCw3LjM1OGMxLjQ0LDAuNTYxLDMuMDAxLDAuODgsNC42NCwwLjg4YzcuMDc2LDAsMTIuODEzLTUuNzM2LDEyLjgxMy0xMi44MTNTMTkuODg4LDAsMTIuODEyLDB6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericModal_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f79f74b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenericModal_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f79f74b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f79f74b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenericModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-mask",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-container",class:{ fullHeightMobile : _vm.fullHeightMobile },style:({ width: _vm.modalWidth + '%', minHeight: _vm.minModalHeight + 'em' })},[_c('button',{staticClass:"modal-close-button",class:{ hideMobile : _vm.hideCloseMobile },on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":__webpack_require__(180)}})]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJDbG9zZV9YIiBkYXRhLW5hbWU9IkNsb3NlL1giIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDQ5IC00NDk4KSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE0NDUiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE0NDUiIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDQ5IDQ0OTgpIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NTQiIGRhdGEtbmFtZT0iUGF0aCA5NTQiIGNsYXNzPSJjbHMtMiIgZD0iTTE0LTEyLjYsMTIuNi0xNCw3LTguNCwxLjQtMTQsMC0xMi42LDUuNi03LDAtMS40LDEuNCwwLDctNS42LDEyLjYsMCwxNC0xLjQsOC40LTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUwIDQ1MTMpIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareProduct_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965fcdc2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareProduct_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-965fcdc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965fcdc2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneNumber_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569fb44f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneNumber_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-569fb44f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_569fb44f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"phone-number"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.areaCode),expression:"areaCode"}],staticClass:"sleek-input phone-number-input area-code",attrs:{"data-modelName":"areaCode","maxlength":"3","type":"number"},domProps:{"value":(_vm.areaCode)},on:{"keyup":[_vm.checkLengthAndTab,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterClick()}],"input":function($event){if($event.target.composing){ return; }_vm.areaCode=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prefix),expression:"prefix"}],staticClass:"sleek-input phone-number-input",attrs:{"data-modelName":"prefix","maxlength":"3","type":"number"},domProps:{"value":(_vm.prefix)},on:{"keyup":[_vm.checkLengthAndTab,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterClick()}],"input":function($event){if($event.target.composing){ return; }_vm.prefix=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lineNumber),expression:"lineNumber"}],staticClass:"sleek-input phone-number-input",attrs:{"data-modelName":"lineNumber","maxlength":"4","type":"number"},domProps:{"value":(_vm.lineNumber)},on:{"keyup":[_vm.checkLineNumberLength,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterClick()}],"input":function($event){if($event.target.composing){ return; }_vm.lineNumber=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-product"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.capitalize('Share Product')))]),_vm._v(" "),_c('section',{staticClass:"share-options"},[_c('section',{staticClass:"option email"},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.isEmailShareOpen = !_vm.isEmailShareOpen}}},[_vm._v("\n        EMAIL\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEmailShareOpen),expression:"!isEmailShareOpen"}],staticClass:"fa fa-angle-down"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEmailShareOpen),expression:"isEmailShareOpen"}],staticClass:"fa fa-angle-up"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEmailShareOpen),expression:"isEmailShareOpen"}],staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailAddress),expression:"emailAddress"}],staticClass:"sleek-input email",attrs:{"placeholder":"Enter email address"},domProps:{"value":(_vm.emailAddress)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendEmailShare($event)},"input":function($event){if($event.target.composing){ return; }_vm.emailAddress=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"sleek-button",class:{ inactive: !_vm.isEmailValid },on:{"click":_vm.sendEmailShare}},[(!_vm.emailIsSending)?_c('span',[_vm._v(_vm._s(_vm.capitalize("Send")))]):_c('LoadingSpinner')],1)])]),_vm._v(" "),_c('section',{staticClass:"option sms"},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.isSmsShareOpen = !_vm.isSmsShareOpen}}},[_vm._v("\n        SMS\n        "),(!_vm.isSmsShareOpen)?_c('i',{staticClass:"fa fa-angle-down"}):_c('i',{staticClass:"fa fa-angle-up"})]),_vm._v(" "),(_vm.isSmsShareOpen)?_c('div',{staticClass:"content"},[_c('PhoneNumber',{ref:"phone-number-component",attrs:{"onEnterClick":_vm.sendSmsShare,"setPhoneNumberValid":function () { return _vm.isPhoneNumberValid = true; },"setPhoneNumberInvalid":function () { return _vm.isPhoneNumberValid = false; }}}),_vm._v(" "),_c('span',{staticClass:"sleek-button",class:{ inactive: !_vm.isPhoneNumberValid },on:{"click":_vm.sendSmsShare}},[(!_vm.smsIsSending)?_c('span',[_vm._v(_vm._s(_vm.capitalize("Send")))]):_c('LoadingSpinner')],1)],1):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"option url"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.onLinkShareClick()}}},[_vm._v("\n        LINK\n        "),(!_vm.isUrlShareOpen)?_c('i',{staticClass:"fa fa-angle-down"}):_c('i',{staticClass:"fa fa-angle-up"})]),_vm._v(" "),(_vm.isUrlShareOpen)?_c('div',{staticClass:"content url-share"},[_c('button',{staticClass:"sleek-button copy-link",on:{"click":function($event){return _vm.copyShareLink()}}},[(!_vm.isLinkLoading)?_c('span',[_vm._v(_vm._s(_vm.capitalize("Copy Link")))]):_c('LoadingSpinner')],1)]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLinkDetails_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459e6098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLinkDetails_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-459e6098"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLinkDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459e6098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLinkDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-link-details"},[_c('section',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.modalProps.productLink.imageUrl,"onerror":"this.style.opacity='0'"}})]),_vm._v(" "),_c('section',{staticClass:"main-content"},[_c('h3',[_vm._v(_vm._s(_vm.productLink.name))]),_vm._v(" "),_c('div',{staticClass:"link"},[_vm._v("\n      At\n      "),(_vm.productLink.isCustom)?_c('a',{staticClass:"product-link",attrs:{"target":"blank"},on:{"click":_vm.onLinkClick}},[_vm._v(_vm._s(_vm.productLink.retailerName))]):_vm._e(),_vm._v(" "),(!_vm.productLink.isCustom)?_c('a',{staticClass:"product-link",attrs:{"target":"blank"},on:{"click":_vm.onLinkClick}},[_vm._v(_vm._s(_vm.productLink.networkRetailer.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"price"},[(_vm.productLink.price)?_c('span',[_vm._v(_vm._s(_vm.numberToCurrency(_vm.productLink.price)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"commission"},[_vm._v("\n      Estimated Commission:\n      "),(_vm.productLink.isCustom && !_vm.productLink.proCommission)?_c('b',[_vm._v(_vm._s(_vm.productLink.proCommissionRate ? _vm.productLink.proCommissionRate * 100 + '%' : 'N/A'))]):_c('b',[_vm._v(_vm._s(_vm.numberToCurrency(_vm.productLink.proCommission)))])]),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('span',{staticClass:"display-button",on:{"click":function($event){return _vm.onCopyShareLinkClick()}}},[_vm._v("Copy Link")]),_vm._v(" "),(_vm.showAddToScript)?_c('span',{staticClass:"display-button",on:{"click":function($event){return _vm.addToScriptClick(_vm.productLink)}}},[_vm._v("\n        Add to Script\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"colors-sizes"},[(_vm.productLink.colors)?_c('span',{staticClass:"colors"},[_c('b',[_vm._v("Available colors:")]),_vm._v(" "+_vm._s(_vm.productLink.colors))]):_vm._e(),_vm._v(" "),(_vm.productLink.sizes)?_c('span',{staticClass:"sizes"},[_c('b',[_vm._v("Available sizes:")]),_vm._v(" "+_vm._s(_vm.productLink.sizes))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"description"},[(_vm.productLink.description)?_c('span',[_vm._v(_vm._s(_vm.productLink.description))]):_c('span',[_vm._v("No description available.")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BxCarousel_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc1ea0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BxCarousel_vue__ = __webpack_require__(217);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bc1ea0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BxCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc1ea0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BxCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./images/icons/green-check.jpg": 206,
	"./images/onboarding/COA_Bx_Carousel_1.jpg": 207,
	"./images/onboarding/COA_Bx_Carousel_10.jpg": 208,
	"./images/onboarding/COA_Bx_Carousel_2.jpg": 209,
	"./images/onboarding/COA_Bx_Carousel_3.jpg": 210,
	"./images/onboarding/COA_Bx_Carousel_4.jpg": 211,
	"./images/onboarding/COA_Bx_Carousel_5.jpg": 212,
	"./images/onboarding/COA_Bx_Carousel_6.jpg": 213,
	"./images/onboarding/COA_Bx_Carousel_7.jpg": 214,
	"./images/onboarding/COA_Bx_Carousel_8.jpg": 215,
	"./images/onboarding/COA_Bx_Carousel_9.jpg": 216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/green-check.c63d38e.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_1.aa33970.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_10.ce5d1a5.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_2.e9982e0.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_3.6e97b68.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_4.7b55945.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_5.53df6ce.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_6.e709797.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_7.8021912.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_8.1be577a.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/COA_Bx_Carousel_9.0024259.jpg";

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-carousel"},[(this.currentSlide > 1)?_c('img',{staticClass:"arrow left",attrs:{"src":"/static/img/icons/keyboard-arrow-left.svg"},on:{"click":function($event){return _vm.prevSlide()}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"current-image",attrs:{"src":_vm.currentImageSource}}),_vm._v(" "),_c('img',{staticClass:"arrow right",attrs:{"src":"/static/img/icons/keyboard-arrow-right.svg"},on:{"click":function($event){return _vm.nextSlide()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropNotification_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfdeb0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropNotification_vue__ = __webpack_require__(220);
function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfdeb0f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container hideContainer"},[_c('div',{staticClass:"drop-notification",on:{"click":_vm.clearNotification}},[(_vm.statusCode === 1)?_c('span',{staticClass:"status-icon"},[_c('img',{attrs:{"src":__webpack_require__(90)}})]):_vm._e(),_vm._v(" "),(_vm.statusCode === 2)?_c('span',{staticClass:"status-icon"},[_c('img',{attrs:{"src":__webpack_require__(90)}})]):_vm._e(),_vm._v(" "),(_vm.statusCode === 3)?_c('span',{staticClass:"status-icon"},[_c('img',{attrs:{"src":__webpack_require__(221)}})]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS4zMDUgMjkuMzA1Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZDYzOTM5OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iSWNvbl9XYXJuaW5nIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNC42NTIsMEExNC42NTIsMTQuNjUyLDAsMSwwLDI5LjMsMTQuNjUyLDE0LjcsMTQuNywwLDAsMCwxNC42NTIsMFptMi4wMTUsMjIuMzQ1SDEyLjYzOHYtMy40OEgxNi44NXYzLjQ4Wk0xNi44NSw4Ljc5MWwtMS4xLDguMDU5aC0yLjJsLTEuMS04LjA1OVY2Ljk2aDQuNTc5VjguNzkxWiIvPgo8L3N2Zz4K"

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__(91);



var state = {
  user: null,
  isSettingCurrentUser: false
};

var mutations = {
  logout: function logout(state) {
    state.user = null;
  },
  setCurrentUser: function setCurrentUser(state, user) {
    state.user = user;
  },
  isSettingCurrentUser: function isSettingCurrentUser(state, boolean) {
    state.isSettingCurrentUser = boolean;
  }
};

var getters = {
  currentUser: function currentUser(state) {
    return state.user;
  },
  isSettingCurrentUser: function isSettingCurrentUser(state) {
    return state.isSettingCurrentUser;
  }
};

var actions = {
  logout: function logout(_ref) {
    var commit = _ref.commit;

    commit('logout');
  },
  setCurrentUser: function setCurrentUser(_ref2) {
    var commit = _ref2.commit;

    commit('isSettingCurrentUser', true);
    return __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* default */].fromToken(localStorage.token).then(function (user) {
      commit('setCurrentUser', user);
      commit('isSettingCurrentUser', false);
      // Turning off 1/22/21
      // if (process.env.NODE_ENV !== 'development') {
      //   this._vm.$intercom.boot({
      //     user_id:        user.id,
      //     name:           user.fullName(),
      //     email:          user.emailAddress,
      //     sign_up_date:   user.createdAt
      //   })
      //   this._vm.$intercom.show()
      // }
    }).catch(function (error) {
      commit('setCurrentUser', null);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  resetCurrentUser: function resetCurrentUser(context, user) {
    context.commit('setCurrentUser', __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* default */].fromObject(user));
  },
  isSettingCurrentUser: function isSettingCurrentUser(_ref3) {
    var commit = _ref3.commit;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  errorMessage: null,
  hideDefault: false
};

var mutations = {
  addError: function addError(state, payload) {
    var errorMessage = 'Server Error. Please try again later.';
    state.errorMessage = payload ? payload.errorMessage : errorMessage;
    state.hideDefault = payload ? payload.hideDefault : false;
  },
  removeError: function removeError(state) {
    state.errorMessage = null;
  }
};

var getters = {
  errorMessage: function errorMessage(state) {
    return state.errorMessage;
  },
  hideDefault: function hideDefault(state) {
    return state.hideDefault;
  }
};

var actions = {
  addError: function addError(context, payload) {
    context.commit('addError', payload);
  },
  removeError: function removeError(context) {
    context.commit('removeError');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper_js__ = __webpack_require__(25);




var state = {
  script: {}
};

var mutations = {
  setScript: function setScript(state, script) {
    state.script = script;
  }
};

var getters = {
  script: function script(state) {
    return state.script;
  }
};

var actions = {
  setScript: function setScript(context, script_id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__["a" /* default */].get('users/' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.currentUser.id + '/scripts/' + script_id).then(function (response) {
      context.commit('setScript', __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper_js__["a" /* default */].camelizeObject(response.data.script));
    });
  },
  updateScript: function updateScript(context, script) {
    context.commit('setScript', script);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_vue_axios_axios__ = __webpack_require__(15);




var state = {
  publicPro: {},
  professions: []
};

var mutations = {
  removeCurrentPro: function removeCurrentPro(state) {
    state.publicPro = {};
  },
  setPublicPro: function setPublicPro(state, user) {
    state.publicPro = user;
  },
  setProfessions: function setProfessions(state, professions) {
    state.professions = professions;
  }
};

var getters = {
  currentPro: function currentPro(state) {
    return state.publicPro;
  },
  professions: function professions(state) {
    return state.professions;
  }
};

var actions = {
  removeCurrentPro: function removeCurrentPro(_ref) {
    var commit = _ref.commit;

    commit('removeCurrentPro');
  },
  setPublicPro: function setPublicPro(_ref2, pro) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(commit('setPublicPro', __WEBPACK_IMPORTED_MODULE_1__models_User__["a" /* default */].fromObject(pro)));
  },
  getProfessions: function getProfessions(context) {
    return __WEBPACK_IMPORTED_MODULE_2__api_vue_axios_axios__["a" /* default */].get('public/users/professions').then(function (response) {
      context.commit('setProfessions', response.data.user_professions);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper__ = __webpack_require__(25);




var state = {
  scriptProductLinks: []
};

var mutations = {
  setScriptProductLinks: function setScriptProductLinks(state, productLinks) {
    state.scriptProductLinks = productLinks;
  },
  addScriptProductLink: function addScriptProductLink(state, productLink) {
    state.scriptProductLinks.push(productLink);
    // TODO: Sort here?
  },
  removeScriptProductLink: function removeScriptProductLink(state, productLink) {
    var index = state.scriptProductLinks.findIndex(function (p) {
      return p.id === productLink.id;
    });
    state.scriptProductLinks.splice(index, 1);
  }
};

var getters = {
  scriptProductLinks: function scriptProductLinks(state) {
    return state.scriptProductLinks; // TODO sort??
  }
};

var actions = {
  getScriptProductLinks: function getScriptProductLinks(context) {
    return __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__["a" /* default */].get('users/' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.currentUser.id + '/scripts/' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.script.id + '/product_links').then(function (response) {
      var product_links = __WEBPACK_IMPORTED_MODULE_2__helpers_stringHelper__["a" /* default */].camelizeArrayOfObjects(response.data.product_links);
      context.commit('setScriptProductLinks', product_links);
    });
  },
  addScriptProductLink: function addScriptProductLink(context, productLink) {
    context.commit('addScriptProductLink', productLink);
  },
  addScriptProductLinks: function addScriptProductLinks(context, productLinks) {
    productLinks.forEach(function (productLink) {
      context.commit('addScriptProductLink', productLink);
    });
  },
  removeScriptProductLinks: function removeScriptProductLinks(context, productLinks) {
    productLinks.forEach(function (productLink) {
      context.commit('removeScriptProductLink', productLink);
    });
  },
  removeScriptProductLink: function removeScriptProductLink(context, productLink) {
    context.commit('removeScriptProductLink', productLink);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_stringHelper_js__ = __webpack_require__(25);



var state = {
  scriptCategories: []
};

var mutations = {
  setScriptCategories: function setScriptCategories(state, scriptCategories) {
    state.scriptCategories = scriptCategories;
  }
};

var getters = {
  scriptCategories: function scriptCategories(state) {
    return state.scriptCategories;
  }
};

var actions = {
  getScriptCategories: function getScriptCategories(context) {
    return __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__["a" /* default */].get('public/script_categories').then(function (response) {
      context.commit('setScriptCategories', __WEBPACK_IMPORTED_MODULE_1__helpers_stringHelper_js__["a" /* default */].camelizeArrayOfObjects(response.data.script_categories));
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__ = __webpack_require__(15);


var state = {
  networkRetailers: []
};

var mutations = {
  setNetworkRetailers: function setNetworkRetailers(state, networkRetailers) {
    state.networkRetailers = networkRetailers;
  }
};

var getters = {
  networkRetailers: function networkRetailers(state) {
    return state.networkRetailers;
  }
};

var actions = {
  getNetworkRetailers: function getNetworkRetailers(context, script_id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_vue_axios_axios__["a" /* default */].get('network_retailers?active=true').then(function (response) {
      context.commit('setNetworkRetailers', response.data.network_retailers);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  showPwaDownloadPrompt: false
};

var mutations = {
  enablePwaDownloadPrompt: function enablePwaDownloadPrompt(state) {
    state.showPwaDownloadPrompt = true;
  },
  disablePwaDownloadPrompt: function disablePwaDownloadPrompt(state) {
    state.showPwaDownloadPrompt = false;
  }
};

var getters = {
  showPwaDownloadPrompt: function showPwaDownloadPrompt(state) {
    return state.showPwaDownloadPrompt;
  }
};

var actions = {
  enablePwaDownloadPrompt: function enablePwaDownloadPrompt(context) {
    context.commit('enablePwaDownloadPrompt');
  },
  disablePwaDownloadPrompt: function disablePwaDownloadPrompt(context) {
    context.commit('disablePwaDownloadPrompt');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  isMobileDevice: false
};

var mutations = {
  setIsMobileDevice: function setIsMobileDevice(state) {
    state.isMobileDevice = true;
  }
};

var getters = {
  isMobileDevice: function isMobileDevice(state) {
    return state.isMobileDevice;
  }
};

var actions = {
  setIsMobileDevice: function setIsMobileDevice(context) {
    context.commit('setIsMobileDevice');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid",class:{ retractPadding : _vm.isRetractPaddingRoute }},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ShutDownPage__ = __webpack_require__(259);



// import axios from '../api/vue-axios/axios'

// import Login from '@/components/Login'
// import Signup from '@/components/Signup'
// import Waitlist from '@/components/Waitlist'
// import UserHome from '@/components/UserHome'
// import LandingPage from '@/components/LandingPage'

// import PageNotFound from '@/components/PageNotFound'
// import LearnMore from '@/components/public/LearnMore'
// import PublicScripts from '@/components/public/PublicScripts'
// import AddProductLinkToScripts from '@/components/AddProductLinkToScripts'
// import Help from '@/components/Help'
// import Terms from '@/components/Terms'
// import Analytics from '@/components/Analytics'
// import Search from '@/components/search/Search'
// import MasterSearch from '@/components/search/MasterSearch'
// import MasterSearchPros from '@/components/search/MasterSearchPros'
// import MasterSearchScripts from '@/components/search/MasterSearchScripts'
// import NetworkRetailer from '@/components/network-retailer/NetworkRetailer'
//
// import ForgotPassword from '@/components/password/ForgotPassword'
// import ResetPassword from '@/components/password/ResetPassword'
//
// import Script from '@/components/Script'
// import addScriptProductLinks from '@/components/script/addScriptProductLinks'
// import EditScript from '@/components/script/EditScript'
// import NewScript from '@/components/script/NewScript'
//
// import ShareScript from '@/components/ShareScript'
// import ShareScriptEmail from '@/components/share/ShareScriptEmail'
// import ShareScriptSms from '@/components/share/ShareScriptSms'
// import ShareScriptUrl from '@/components/share/ShareScriptUrl'
//
// import UserProfile from '@/components/user/Profile'
// import UserSettings from '@/components/user/Settings'
// import Refer from '@/components/user/Refer'
// import CompleteApplication from '@/components/user/CompleteApplication'
//
// import ProProfile from '@/components/pro/ProProfile'
// import ProScripts from '@/components/pro/ProScripts'
// import ProScript from '@/components/pro/ProScript'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  mode: 'history',
  routes: [{
    path: '/',
    name: 'ShutDownPage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ShutDownPage__["a" /* default */]
  }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_3__components_ShutDownPage__["a" /* default */]
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/signup',
    //   name: 'Signup',
    //   component: Signup,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/waitlist',
    //   name: 'Waitlist',
    //   component: Waitlist,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/forgot-password',
    //   name: 'ForgotPassword',
    //   component: ForgotPassword,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/complete-application',
    //   name: 'CompleteApplication',
    //   component: CompleteApplication,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/reset-password',
    //   name: 'ResetPassword',
    //   component: ResetPassword,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/learn-more',
    //   name: 'LearnMore',
    //   component: LearnMore,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/pro-scripts',
    //   name: 'PublicScripts',
    //   component: PublicScripts,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/master-search',
    //   name: 'MasterSearch',
    //   component: MasterSearch,
    //   children: [
    //     {
    //       path: 'pros',
    //       name: 'MasterSearchPros',
    //       component: MasterSearchPros
    //     },
    //     {
    //       path: 'scripts',
    //       name: 'MasterSearchScripts',
    //       component: MasterSearchScripts
    //     }
    //   ]
    // },
    // {
    //   path: '/terms',
    //   name: 'Terms',
    //   component: Terms
    // },
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: UserHome,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/search',
    //   name: 'Search',
    //   component: Search,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/new-script',
    //   name: 'NewScript',
    //   component: NewScript,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/user-profile',
    //   name: 'UserProfile',
    //   component: UserProfile,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/user-settings',
    //   name: 'UserSettings',
    //   component: UserSettings,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/refer',
    //   name: 'Refer',
    //   component: Refer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/help',
    //   name: 'Help',
    //   component: Help,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/analytics',
    //   name: 'Analytics',
    //   component: Analytics,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/network-retailers/:retailer_id',
    //   name: 'NetworkRetailer',
    //   component: NetworkRetailer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/scripts/:script_id',
    //   name: 'Script',
    //   component: Script,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     // {
    //     //   path: 'add',
    //     //   name: 'addScriptProductLinks',
    //     //   component: addScriptProductLinks
    //     // },
    //     {
    //       path: 'edit',
    //       name: 'EditScript',
    //       component: EditScript
    //     },
    //     {
    //       path: 'share',
    //       name: 'ShareScript',
    //       component: ShareScript,
    //       children: [
    //         {
    //           path: 'email',
    //           name: 'ShareScriptEmail',
    //           component: ShareScriptEmail
    //         },
    //         {
    //           path: 'sms',
    //           name: 'ShareScriptSms',
    //           component: ShareScriptSms
    //         },
    //         {
    //           path: 'url',
    //           name: 'ShareScriptUrl',
    //           component: ShareScriptUrl
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: '/scripts/:script_id/add',
    //   name: 'addScriptProductLinks',
    //   component: addScriptProductLinks,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/product-links/:product_link_id/add-to-scripts',
    //   name: 'AddProductLinkToScripts',
    //   component: AddProductLinkToScripts,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/404',
    //   name: 'PageNotFound',
    //   component: PageNotFound
    // },
    // // I believe that this must always be the last route defined, as we want other /root routes to take precedence over this one.
    // {
    //   path: '/:identifier',
    //   component: ProProfile,
    //   beforeEnter: (to, from, next) => {
    //     let identifier = to.params.identifier
    //     axios.get('/users/' + identifier + '/profile').then((response) => {
    //       store.dispatch('setPublicPro', response.data.user).then(() => {
    //         next()
    //       })
    //     }).catch((res) => {
    //       if (res.response.status === 404) {
    //         next({ path: '/404' })
    //       }
    //     })
    //     // window.Intercom('shutdown')
    //   },
    //   children: [
    //     {
    //       path: '',
    //       name: 'ProScripts',
    //       component: ProScripts
    //     },
    //     {
    //       path: 'scripts/:scriptId',
    //       name: 'ProScript',
    //       component: ProScript
    //     }
    //   ]
    // }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.blockedForUsers;
  }) && (__WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].getters.currentUser || localStorage.token)) {
    // Route is off-limits to logged-in users
    // Return them to homne page
    var path = '/home';

    return next({
      path: path
    });
  }

  if (!to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // route is open to unauthenticated users
    return next();
  }

  // User token exists but currentUser has not been set (aka hard load on app)
  // We need to set current user and then go on our way
  if (localStorage.token && !__WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].getters.currentUser) {
    __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].dispatch('setCurrentUser').then(function (user) {
      __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].dispatch('getNetworkRetailers').then(function () {
        next();
      });
    }).catch(function () {
      // If there's an error retrieving/setting the user, redirect to login
      // #setCurrentUser will handle setting the currentUser to null :)
      delete localStorage.token;
      router.push({ name: 'Login' });
    });
  } else {
    // trying to access a route that requires auth. Make sure we have a user. If not, throw up redirect
    if (__WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].getters.currentUser) next();else next('/login?redirect=' + to.path);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShutDownPage_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e0b97c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShutDownPage_vue__ = __webpack_require__(261);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e0b97c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShutDownPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e0b97c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShutDownPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shut-down-page"},[_c('div',{staticClass:"form-wrapper border border-light"},[_c('img',{staticClass:"bs-logo",attrs:{"src":__webpack_require__(78)}}),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._v("\n      Hello Beautiful! Thanks for stopping by, and if you were a Bx user, thank you for all your support.\n      While we remain committed to the idea of Beauty Scripts as a game changer for the industry,\n      we've hit the end of our road in bringing it forward. \n    ")]),_vm._v(" "),_c('div',{staticClass:"signoff"},[_vm._v("Wishing you all the best!")]),_vm._v(" "),_c('div',{staticClass:"signoff italic"},[_vm._v("Greta (founder) & the Bx Team")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_dateHelper__ = __webpack_require__(399);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formatShortDateString: function formatShortDateString(jsonDateString) {
      if (!jsonDateString) return '';
      var dt = __WEBPACK_IMPORTED_MODULE_0__helpers_dateHelper__["a" /* default */].createDateFromJSON(jsonDateString);
      return __WEBPACK_IMPORTED_MODULE_0__helpers_dateHelper__["a" /* default */].getShortDateString(dt);
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var dateHelper = function () {
  function createDateFromJSON(jsonDateString) {
    var parts = jsonDateString.match(/(\d+)/g);
    var dt = new Date(parts[0], parts[1] - 1, parts[2]); // parse into yyyy, m, d
    var hours = jsonDateString.substring(11, 13);
    var minutes = jsonDateString.substring(14, 16);
    var seconds = jsonDateString.substring(17, 19);
    dt.setHours(hours, minutes, seconds, 0);
    return dt;
  }

  function getShortDateString(dt) {
    var year = dt.getFullYear();
    var day = dt.getDate();
    var month = dt.getMonth() + 1;
    return month + '/' + day + '/' + year;
  }

  function createUrlDate(date) {
    var day = date.getDate().toString();
    var month = (date.getMonth() + 1).toString(); // Months in JavaScript are 0 indexed
    var year = date.getFullYear().toString();

    if (day.length === 1) day = '0' + day;
    if (month.length === 1) month = '0' + month;

    return year + month + day;
  }

  function getUrlDateString(startDate, endDate) {
    return '?start_date=' + createUrlDate(startDate) + '&end_date=' + createUrlDate(endDate);
  }

  return {
    createDateFromJSON: createDateFromJSON,
    getShortDateString: getShortDateString,
    createUrlDate: createUrlDate,
    getUrlDateString: getUrlDateString
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (dateHelper);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numberHelper__ = __webpack_require__(401);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    capitalize: function capitalize(string) {
      if (!string) return '';
      return string.toUpperCase();
    },
    numberToCurrency: function numberToCurrency(number) {
      return __WEBPACK_IMPORTED_MODULE_0__helpers_numberHelper__["a" /* default */].numberToCurrency(number);
    },
    decimalToPercentage: function decimalToPercentage(decimal) {
      return decimal * 100;
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var numberHelper = function () {
  function numberToCurrency(number) {
    if (!number) return 'N/A';
    var amount = parseFloat(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return '$' + amount.toString();
  }

  return {
    numberToCurrency: numberToCurrency
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (numberHelper);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[117]);


// WEBPACK FOOTER //
// static/js/app.5095ed98852323bef8ff.js